import { render, staticRenderFns } from "./bsdwzCN.vue?vue&type=template&id=7c39eb55&scoped=true&"
import script from "./bsdwzCN.vue?vue&type=script&lang=js&"
export * from "./bsdwzCN.vue?vue&type=script&lang=js&"
import style0 from "./bsdwzCN.vue?vue&type=style&index=0&id=7c39eb55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c39eb55",
  null
  
)

export default component.exports